'use client';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { ArrowLeftIcon } from '@depop/web-ui-kit/Icons/ArrowLeftIcon';
import { ArrowRightIcon } from '@depop/web-ui-kit/Icons/ArrowRightIcon';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { StepProgressBar } from '@/components/StepProgressBar';

type Props = {
  currentStep: number;
  totalSteps: number;
  onBack?: () => void;
  onNext?: () => void;
  isBackDisabled?: boolean;
  isNextDisabled?: boolean;
};

export function NavigableStepProgressBar({
  currentStep,
  totalSteps,
  onBack,
  onNext,
  isBackDisabled = false,
  isNextDisabled = false,
}: Props) {
  const t = useTranslations('common');
  if (currentStep < 0 || totalSteps <= 0 || currentStep > totalSteps) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <Caption
        id="progress-label"
        variant="lg-regular"
        className={styles.progressionBarText}
      >
        {currentStep} of {totalSteps}
      </Caption>
      <div className={styles.navigationWrapper}>
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            disabled={isBackDisabled}
            className={styles.navButton}
            aria-label={t('NavigableStepProgressBar.Back')}
          >
            <ArrowLeftIcon size={24} className={styles.navButtonIcon} />
          </button>
        ) : (
          <span className={styles.navButtonPlaceholder} aria-hidden />
        )}
        <div className={styles.barArea}>
          <StepProgressBar
            currentStep={currentStep}
            totalSteps={totalSteps}
            labelId="progress-label"
          />
        </div>
        {onNext ? (
          <button
            type="button"
            onClick={onNext}
            disabled={isNextDisabled}
            className={styles.navButton}
            aria-label={t('NavigableStepProgressBar.Next')}
          >
            <ArrowRightIcon size={24} className={styles.navButtonIcon} />
          </button>
        ) : (
          <span className={styles.navButtonPlaceholder} aria-hidden />
        )}
      </div>
    </div>
  );
}
